// extracted by mini-css-extract-plugin
export default {"wrapper":"InputImage_wrapper__7xV7q","input":"InputImage_input__zqzKg","label":"InputImage_label__fwXIp","upload":"InputImage_upload__ZKQrd","button":"InputImage_button__6K09A"};